export enum AddrSysFlag {
    Predefined = 'Predefined',
    GoogleMap = 'GoogleMap',
    SGMap = 'SGMap',
    CustomerAddress = 'CustomerAddress'
}
